import React, { createContext } from 'react';

const ConditionContext = createContext({});

const conditionIs = { selected: "is", notSelected: "" };

export { ConditionContext, conditionIs };
